import React, { useEffect, useRef, useState } from 'react';
import { bool, func, string } from 'prop-types';
import AUIDropdown from '@ancert/aui-dropdown';
import { toBase64 } from '@ancert/aui-utils';
import AudioRecorderModal from './AudioRecorderModal';
import { dropdownSelected, optionTemplate, valueTemplate } from './templates';
import { OPTIONS_VALUE, OPTIONS } from './options';
import { MAX_AUDIO_SIZE } from '../../config';
import TIPO_ADJUNTO from '../../lib/adjuntos.enum';

const DropdownAudio = ({ defaultValue, readOnly, onSelect }) => {
  const inputUploadRef = useRef(null);
  const [audioSelection, setAudioSelection] = useState(null);
  const [openRecorder, setOpenRecorder] = useState(false);

  useEffect(() => {
    setAudioSelection(defaultValue);
  }, [defaultValue]);
  const onChangeDropdown = ({ value }) => {
    if (value === OPTIONS_VALUE.GRABAR) {
      setOpenRecorder(true);
    }
  };

  const onInputFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }

    // eslint-disable-next-line no-param-reassign
    event.target.value = null;
    if (fileObj.size > MAX_AUDIO_SIZE) {
      return;
    }

    const returnData = {
      name: fileObj.name,
      rawFile: fileObj,
      base64File: await toBase64(fileObj),
      type: TIPO_ADJUNTO.MP3,
    };

    setAudioSelection(fileObj.name);
    onSelect(returnData);
  };

  const onAcceptAudioRecorder = (returnData) => {
    setAudioSelection(returnData.name);
    setOpenRecorder(false);
    onSelect(returnData);
  };

  const onClickDelete = () => {
    onSelect();
    setAudioSelection(null);
  };
  return audioSelection ? (
    dropdownSelected({ nombreAudio: audioSelection, onClickDelete, readOnly })
  ) : (
    <>
      <AUIDropdown
        appendTo={null}
        className="c-sii-dropdown-audio"
        itemTemplate={(option) => optionTemplate({ option, inputUploadRef })}
        valueTemplate={valueTemplate}
        value={OPTIONS_VALUE.SELECCIONAR}
        options={OPTIONS}
        onChange={onChangeDropdown}
      />
      <input
        ref={inputUploadRef}
        className="c-sii-dropdown-audio__template--upload"
        type="file"
        accept=".mp3"
        onChange={onInputFileChange}
      />
      {openRecorder && (
        <AudioRecorderModal
          show={openRecorder}
          onAccept={onAcceptAudioRecorder}
          onClose={() => setOpenRecorder(false)}
        />
      )}
    </>
  );
};
DropdownAudio.propTypes = {
  defaultValue: string,
  readOnly: bool,
  onSelect: func,
};
DropdownAudio.defaultProps = {
  defaultValue: '',
  readOnly: false,
  onSelect: () => null,
};

export default DropdownAudio;
